import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { Paragraph } from '@/components/typography/Paragraph';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/styles';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import styles from './MobileMenu.module.css';
interface CTAButtonsProps {
  readonly login?: Data.Component<'utilities.link'> | null;
  readonly buttons?: Data.Component<'utilities.link'>[] | null;
  readonly dropdown?: Data.Component<'layout-utilities.dropdown-item'> | null;
  readonly className?: string;
  readonly navContext?: 'menu-items' | 'menu-content';
  onDropdownClick?: () => void;
}
export const CTAButtons = t0 => {
  const $ = _c(17);
  const {
    login,
    buttons,
    dropdown,
    className,
    navContext: t1,
    onDropdownClick
  } = t0;
  const navContext = t1 === undefined ? "menu-items" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex gap-8 flex-col w-full pb-8", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== login || $[3] !== navContext) {
    t3 = login?.href && login?.label ? <div className={cn("w-full border-b border-neutral-light-500 py-8")}><AppLink href={login.href} openExternalInNewTab={!!login.newTab} data-test-id={NAVBAR_TEST_IDS.LOGIN_BUTTON}><Paragraph fontSize={navContext === "menu-items" ? "displaySmall" : "headingMedium"} className={cn("text-inherit", styles["menu-link"])}>{login.label}</Paragraph></AppLink><div className="mx-4 w-px bg-neutral-light-500 h-6 hidden" /></div> : null;
    $[2] = login;
    $[3] = navContext;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== buttons) {
    t4 = buttons && buttons.length > 0 ? buttons.map(_temp) : null;
    $[5] = buttons;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== dropdown || $[8] !== onDropdownClick) {
    t5 = dropdown ? <Button variant="secondary" size="large" className="w-full" onClick={onDropdownClick}>{dropdown.label}</Button> : null;
    $[7] = dropdown;
    $[8] = onDropdownClick;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-3">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp(primaryButton) {
  return primaryButton.href ? <AppLink key={primaryButton.id} size="large" variant="primary" href={primaryButton.href} openExternalInNewTab={!!primaryButton.newTab} data-test-id={NAVBAR_TEST_IDS.PRIMARY_BUTTON} className="w-full">{primaryButton.label}</AppLink> : null;
}